module.exports = __webpack_public_path__ + "static/img/outlineBorder2.6f921b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/outlineBorder2.png
// module id = Ujb9
// module chunks = 1